import React from 'react';
import { Link } from '@americanexpress/one-app-router';

const NavLinks = () => (
  <>
    <br />
    <Link href="/">Everything</Link><br />
    <Link href="/header-only">Header Only</Link><br />
    <Link href="/footer-only">Footer Only</Link><br />
    <Link href="/content-only">Content Only</Link><br />
    <Link href="/page-wrapper">Page Wrapper Only</Link><br />
    <Link href="/nav-only">Nav Only</Link><br />
    <br />
  </>
);

NavLinks.propTypes = {};

export default NavLinks;
